import { Activity } from '../../../features/inbox/types/Activity';
import { FrontierHotel } from '../../../globalModels/hotels/frontier/frontierHotel';
import { EntityNoteModel } from '../../../globalModels/entityNotes/entityNoteModel';
import CompanyProjectStatus from '../../../enums/crm/CompanyProjectStatus';

export type CompanyProject = {
  Id?: number;
  Active: boolean;
  Activity: Activity;
  ContactName: string;
  PhoneNumber: string;
  Email: string;
  ProjectLocation: string;
  NumberWorkingOnProject: number;
  IsNightShift: boolean;
  ProjectStage: string;
  NightShiftTime: string;
  DelayDescription: string;
  RampDescription: string;
  DidStartInReservations: boolean;
  RoomsRequiredDuration: string;
  ParkingRequirements: string;
  IsJobCodingSame: string;
  EstimatedBudget: string;
  Budget: number;
  CityDescription: string;
  HotelDescription: string;
  AssignedToUserId: string;
  AssignedToUserName: string;
  BarRate: string;
  BillingPeriod: string;
  BookingMethod: string;
  CityNames: string;
  CityIds: number[];
  Coding: string;
  Commission: string;
  CompanyId: number;
  CompanyName: string;
  ContactId?: number;
  EndDate?: string;
  Fop: string;
  HotelContact: string;
  Hotels: FrontierHotel[];
  Information: string;
  Name: string;
  NumberOfRooms: string;
  Rate: string;
  RoomType: string;
  StartDate?: string;
  Status: CompanyProjectStatus;
  TypeOfGroup: CompanyProjectGroupType;
  Updates: string;
  Notes: EntityNoteModel[];
  IsBreakfast: boolean;
  IsLaundryServices: boolean;
  IsMeetingRoom: boolean;
  IsPool: boolean;
  IsRestaurant: boolean;
  IsBaggedLunch: boolean;
  IsOtherAmenity: boolean;
  ProjectStates: CompanyProjectState[];
  FopList: CompanyProjectFop[];
  Approval: CompanyProjectApproval;
  InquiryStatus: number;
  AssignmentStatus: number;
  SourcingStatus: number;
  ContractStatus: number;
  MaintenanceStatus: number;
  CompletionStatus: number;
  LaunchStatus: number;
};

export enum CompanyProjectGroupType {
  None = 0,
  LongTerm = 1,
  SmallGroup = 2,
  LargeGroup = 3
}

type CompanyProjectState = {
  Id?: number;
  Approval: string;
  CompanyProjectId: number;
  CreatedBy: string;
  CreatedOn: string;
  Step: string;
};

type CompanyProjectFop = {
  Id?: number;
  CompanyProjectId: number;
  CreatedBy: string;
  CreatedOn: string;
  Fop: string;
};

enum CompanyProjectApproval {
  Incomplete = 0,
  AgentComplete = 1,
  ManagerComplete = 2
}
